/* YipYap: progressive enhancement; content is visible even when motion is unavailable. */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver((entries) => {
    entries.forEach(({ isIntersecting, target }) => {
      if (!isIntersecting || target.dataset.yyRevealed) return;
      target.dataset.yyRevealed = 'true';
      observer.unobserve(target);
      if (reducedMotion.matches || typeof target.animate !== 'function') return;
      target.animate([
        { opacity: 0.55, transform: 'translateY(18px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 650, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
    });
  }, { threshold: 0.12 }) : null;
  function initialize(root = document) {
    if (!observer || reducedMotion.matches) return;
    root.querySelectorAll('[data-yy-reveal]').forEach((element) => {
      if (!element.dataset.yyRevealed) observer.observe(element);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
